import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ColDef, RowNode } from 'ag-grid-community';

import { NSEBillConstants } from '@ruby/configs/ebill.constants';
import { EBillRouteEnum } from '@ruby/shared/enums/ebill.enums';
import { IEBillCustomer, IEBillLocationCodes } from '@ruby/shared/models/ebill/ebil.interface';

@Component({
  selector: 'ng-ebill-locations-component',
  templateUrl: './ebill-location.component.html',
  styleUrls: ['./ebill-location.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EBillLocationComponent {
  @Input() data!: Array<IEBillCustomer>;
  @Input() selectedCustomer?: IEBillCustomer;
  @Input() userRacf?: string;
  @Input() loading!: boolean;
  @Output() navigate = new EventEmitter<{ locations: IEBillLocationCodes; route: EBillRouteEnum }>();
  columns: Array<ColDef> = NSEBillConstants.locationsGridColumns;
  gridConfig = NSEBillConstants.customerGridConfig;
  selectedAction = EBillRouteEnum.DASHBOARD;
  commons = EBillRouteEnum;
  selectedRows: Array<RowNode> = [];

  constructor() {}

  /**
   * Selection Change
   *
   * @summary cache selected rows
   * @param $rows: Array<RowNode>
   * @returns void
   */
  selectionChange($rows: Array<RowNode>): void {
    this.selectedRows = $rows;
  }

  /**
   * update Locations
   *
   * @summary update selected locations
   * @returns void
   */
  updateLocations(): void {
    this.navigate.emit({
      locations: {
        locationCodes: this.selectedRows.map((node: RowNode) => node.data.locationCode),
        nationalAccount: this.selectedCustomer!.primary6,
        userRacf: this.userRacf!
      },
      route: this.selectedAction
    });
  }
}
